import tw from "twin.macro";

export const CollapsedWrapper = tw.div`
  w-full flex gap-4 flex-nowrap overflow-hidden relative
`;
export const ExpandedWrapper = tw.div`
  w-full flex gap-4 flex-wrap overflow-hidden relative
`;
export const ToggleExtendCollapseWrapper = tw.div`absolute right-0 translate-x-[-0%] top-[8px]`;
